import axios from "axios";
import { API } from "./api";

export const memberApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

// pages where logout redirect should NOT trigger
const authPages = [
  "/member/login",
  "/member/register",
  "/member/verify",
];

// =====================================
// REQUEST INTERCEPTOR
// =====================================
memberApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("ospf_member_token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// =====================================
// RESPONSE INTERCEPTOR
// =====================================
memberApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const currentPath = window.location.pathname;

    if (status === 401) {
      const isAuthPage = authPages.some((page) =>
        currentPath.startsWith(page)
      );

      const isMemberArea =
        currentPath.startsWith("/member") ||
        currentPath.startsWith("/membership");

      // only logout if protected member page
      if (isMemberArea && !isAuthPage) {
        localStorage.removeItem("ospf_member_token");

        window.location.href = "/member/login";
      }
    }

    return Promise.reject(error);
  }
);